export const dentistAdvantages = [
  {
    title: "Aynı gün rapor",
    text: "Çekim biter bitmez dijital rapor hazırlanır; aynı gün kliniğinize ulaşır.",
  },
  {
    title: "Standart formatlar",
    text: "DICOM, JPG, PNG ve PDF — kullandığınız görüntüleme yazılımıyla tam uyumlu teslim.",
  },
  {
    title: "Online erişim",
    text: "DICOM bulut depolama veya WhatsApp / e-posta üzerinden hızlı ve güvenli paylaşım.",
  },
  {
    title: "Düşük doz, modern cihazlar",
    text: "ALARA prensibiyle minimum radyasyon, maksimum görüntü kalitesi.",
  },
  {
    title: "Tüm radyoloji tek merkezde",
    text: "Panoramik, CBCT, sefalometrik, TME ve periapikal çekimlerin tamamı.",
  },
  {
    title: "Klinik istem formu",
    text: "Kliniğinize özel basılı veya dijital istem formu hazırlanabilir; süreç standardize edilir.",
  },
  {
    title: "Toplu sevk kolaylığı",
    text: "Düzenli yönlendirme yapan kliniklere özel fiyat ve öncelikli randevu dilimi.",
  },
  {
    title: "Radyoloji uzmanı desteği",
    text: "Gerekli durumlarda klinik konsültasyon ve teknik görüş desteği sağlanır.",
  },
];

export const dentistWorkflow = [
  {
    step: "01",
    title: "Klinik yönlendirmesi",
    text: "Hastanıza gerekli çekimi belirtir veya kendi istem formunuzu verirsiniz.",
  },
  {
    step: "02",
    title: "Hasta WhatsApp'tan yazar",
    text: "Hekiminizin adını ve istenen filmi belirterek randevu alır; öncelikli saat ayrılır.",
  },
  {
    step: "03",
    title: "Çekim",
    text: "Hastanız merkezimize gelir; teknisyen doğru protokolü uygular.",
  },
  {
    step: "04",
    title: "Kalite kontrolü",
    text: "Görüntü aynı seansta kontrol edilir; gerekiyorsa tekrarlanır.",
  },
  {
    step: "05",
    title: "Raporlama",
    text: "Uzman radyoloji değerlendirmesi aynı gün içinde tamamlanır.",
  },
  {
    step: "06",
    title: "Size iletim",
    text: "Görüntü ve rapor, tercih ettiğiniz kanalla (WhatsApp, e-posta, DICOM bulut) kliniğinize iletilir.",
  },
];

export const dentistSolutions = [
  {
    title: "İstem formu",
    text: "Kliniğinize özel basılı veya dijital istem formu tasarlanabilir.",
  },
  {
    title: "Toplu sevk indirimi",
    text: "Ayda belirli sayının üzerinde sevk yapan kliniklere özel fiyatlandırma sunulur.",
  },
  {
    title: "Öncelikli saat",
    text: "Anlaşmalı klinik hastaları için öncelikli randevu dilimleri ayrılır.",
  },
  {
    title: "Doğrudan raporlama",
    text: "Görüntüler hastaya değil, doğrudan kliniğinize teslim edilebilir.",
  },
  {
    title: "Eğitim desteği",
    text: "Talep ettiğinizde kliniğinizde çekim endikasyonları ve yorumlama üzerine kısa sunum yapılır.",
  },
];

export const dentistReportRows = [
  { name: "Y. Kaya", type: "CBCT", time: "14:32", files: ["DICOM", "JPG", "PDF"] },
  { name: "M. Aydın", type: "PANO", time: "13:18", files: ["DICOM", "JPG"] },
  { name: "A. Şen", type: "SEF", time: "11:45", files: ["JPG", "PDF"] },
  { name: "E. Demir", type: "TME", time: "10:20", files: ["JPG"] },
];

export const dentistFaqs = [
  {
    question: "Görüntüleri hangi formatta alıyoruz?",
    answer:
      "DICOM (3D ve 2D), JPG/PNG (rapor görüntüsü) ve PDF (yazılı rapor) olarak teslim edilir. Kullandığınız görüntüleme yazılımıyla uyumlu şekilde hazırlanır. CBCT çekimlerinde DICOM klasör yapısı eksiksiz olarak verilir.",
  },
  {
    question: "Raporlar ne zaman hazır olur?",
    answer:
      "Çekim bittikten sonra görüntü aynı seansta kontrol edilir. Uzman radyoloji raporu aynı gün içinde hazırlanır ve WhatsApp / e-posta / DICOM bulut üzerinden iletilir. Acil durumlarda rapor bekletilmeden gönderilebilir.",
  },
  {
    question: "Kendi istem formumuzu kullanabilir miyiz?",
    answer:
      "Evet. Kliniğinize özel basılı veya dijital istem formu tasarlanabilir, süreçler standardize edilebilir. Dijital formu kliniğinizin sistemine entegre edebilir ya da WhatsApp'tan paylaşılacak bir bağlantı olarak hazırlayabiliriz.",
  },
  {
    question: "Toplu sevk yapan klinikler için özel fiyat var mı?",
    answer:
      "Evet. Ayda belirli sayının üzerinde sevk yapan kliniklere özel paket fiyat ve öncelikli randevu dilimi sunulur. Detaylar için WhatsApp'tan yazabilirsiniz.",
  },
  {
    question: "DICOM bulut erişimi var mı?",
    answer:
      "Evet. Anlaşmalı klinikler için şifreli DICOM bulut erişimi sağlanabilir. Görüntüleri kendi PACS sisteminize doğrudan aktarabilirsiniz.",
  },
  {
    question: "Radyoloji konsültasyonu alabilir miyiz?",
    answer:
      "Karmaşık vakalarda uzman radyoloji konsültasyonu talep edebilirsiniz. Görüntü üzerinde birlikte değerlendirme ve yorumlama desteği sağlanır.",
  },
];